import { ISimulationPayload } from '../types';
import { validateStep1CommercialGroup } from './step1-commercial-group';
import { validateStep2BaseScenario } from './step2-base-scenario';
import { z } from 'zod';
import { validateStep3TargetScenario } from './step3-target-scenario';
export const validateAllStepsAccumulate = (params: {
  data: ISimulationPayload;
  ctx: {
    addIssue: (issue: z.IssueData) => void;
  };
}): boolean => {
  const { data, ctx } = params;
  let hasErrors = false;
  if (!validateStep1CommercialGroup(data, ctx)) {
    hasErrors = true;
  }
  if (!validateStep2BaseScenario(data, ctx)) {
    hasErrors = true;
  }
  const targetScenarios = data.inputs?.parsedPayload?.targetScenarios ?? [];
  targetScenarios.forEach((targetScenario, targetIndex) => {
    targetScenario?.scenarioPayload?.forEach((unitPresetPayload) => {
      const energyPricesProjection = (unitPresetPayload?.presetPayload?.rawEnergyPrice?.rawPriceList ?? null) as Record<
        string,
        number
      > | null;
      const marginFeeProjection = (unitPresetPayload?.presetPayload?.marginFee?.values ?? null) as Record<
        string,
        number
      > | null;
      const valid = validateStep3TargetScenario({
        data,
        targetIndex,
        ctx,
        energyPricesProjection,
        marginFeeProjection,
      });
      if (!valid) hasErrors = true;
    });
  });
  return !hasErrors;
};

export const validateAllSteps = validateAllStepsAccumulate;
